module.exports = __webpack_public_path__ + "static/img/tutorial-report-1.c6e3b24.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tutorial-report-1.jpg
// module id = zscX
// module chunks = 3